import { createContext, useContext, useState, useEffect } from 'react';
import { publicApi } from '../api';

const SeasonContext = createContext(null);

export const SeasonProvider = ({ children }) => {
  const [season, setSeason]         = useState(null);
  const [nextSeason, setNextSeason] = useState(null);
  const [loading, setLoading]       = useState(true);

  useEffect(() => {
    publicApi.get('saisons')
      .then(data => {
        // Nouveau format { current, next } ; ancien format (objet direct) géré en fallback.
        // `publicApi.get` renvoie [] en cas d'échec réseau/HTTP : ne pas le prendre pour une saison.
        if (data && typeof data === 'object' && !Array.isArray(data) && 'current' in data) {
          setSeason(data.current || null);
          setNextSeason(data.next || null);
        } else if (data && typeof data === 'object' && !Array.isArray(data)) {
          setSeason(data);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // Libellé "2026/2027" dérivé des dates de la saison en cours, pour tout affichage
  // qui mentionne la saison sans dépendre du texte libre `description`.
  const seasonLabel = season?.start_date && season?.end_date
    ? `${new Date(season.start_date).getFullYear()}/${new Date(season.end_date).getFullYear()}`
    : null;

  return (
    <SeasonContext.Provider value={{ season, nextSeason, loading, seasonLabel }}>
      {children}
    </SeasonContext.Provider>
  );
};

export const useSeason = () => useContext(SeasonContext);
